import { FC } from 'react'
import { ISafetyCaseRiskMatrixCell } from '../../interfaces'
import { calcFontColor } from '../../util/font-color-calculator'

type RiskBadgeProps = {
  risk?: ISafetyCaseRiskMatrixCell
}

const RiskBadge: FC<RiskBadgeProps> = ({ risk }) => (
  <span
    className="badge ml-2"
    style={{
      backgroundColor: risk?.riskColor,
      color: calcFontColor(risk?.riskColor),
    }}
    data-test-id="risk-badge"
  >
    {risk?.riskLabel ?? ''}
  </span>
)

export default RiskBadge
